// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__4f8WB","fileDisabled":"File_fileDisabled__3OaQi"};